module.exports = __webpack_public_path__ + "img/scrub.34b7a25b.svg";